import React from "react";

// For converting Preview topology to PDF it converts to canvas firstly.
// Canvas can't work with SVG sprites so we cannot use regular Icon component.

export const IconPDF = ({ name, ...props }) => {
  const icons = {
    "TROX-logo": (
      <svg
        width="126"
        height="32"
        viewBox="0 0 126 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.775 16.002c0-4.98 3.891-9.015 8.69-9.015 4.8 0 8.69 4.035 8.69 9.014 0 4.98-3.906 9.015-8.69 9.015-4.784 0-8.69-4.035-8.69-9.014zm-7.69 0C61.085 7.164 68.417 0 77.465 0c9.048 0 16.38 7.164 16.38 16.002 0 8.837-7.332 15.998-16.38 15.998-9.048 0-16.38-7.164-16.38-15.998z"
          fill="#004395"
        />
        <path
          d="M25.362 1.139v6.118h-8.714s0 23.97-.021 24.476h-7.75s-.03-22.21 0-24.473H0V1.139h25.362zM102.578 31.52h-7.933L116.037.925h7.933l-21.392 30.593zM117.425 31.522h7.94l-.869-1.22-7.936.003.865 1.217zM96.616 2.314l7.924-.003-.949-1.34h-7.934l.959 1.343zM98.765 5.322l7.927.012-.947-1.35-7.933-.002.953 1.34zM101 8.462h7.93l-.958-1.35-7.93.01.958 1.34zM103.23 11.6h3.864l.98-1.395-5.848-.01 1.004 1.404zM115.151 28.33l7.948-.002-.863-1.208h-7.951l.866 1.21zM113.035 25.35h7.918l-.883-1.211h-7.9l.865 1.211zM110.839 22.303l7.948.003-.875-1.235-6.22.006-.853 1.226zM112.822 19.352h3.861l-.835-1.196h-2.173l-.853 1.196zM105.183 14.337l.745-1.076h-1.517l.772 1.076zM57.428 31.802l-8.681-.021-9.526-12.82-.018 12.772h-7.66V1.013h12.603c1.605 0 11.076.25 11.269 9.95.15 7.737-5.41 9.128-6.57 9.315l8.583 11.524zM39.203 15.827h3.951s4.77.3 4.616-4.351c-.141-4.261-4.186-4.03-4.874-4.03h-3.693v8.381z"
          fill="#004395"
        />
      </svg>
    ),
    "tech-symbol-4-way": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 21v-4H9v-3h4V9h10v1.5h-8.5V13H23v1.5h-8.5V17H23v1.5h-8.5V21H23v1.5H13V21z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-ahu": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M7.366 17.234h1.96L8.36 12.74h-.028l-.966 4.494zm-.266-6.23h2.492L12.238 21h-2.1l-.462-2.114h-2.66L6.554 21h-2.1L7.1 11.004zm5.833 0h2.016v3.822h2.352v-3.822h2.016V21h-2.016v-4.438H14.95V21h-2.016v-9.996zm9.67 0v6.972c0 .252.014.485.042.7.037.205.098.387.182.546.093.15.214.27.364.364.149.084.345.126.588.126.233 0 .424-.042.574-.126a.973.973 0 0 0 .364-.364c.093-.159.154-.34.182-.546.037-.215.056-.448.056-.7v-6.972h2.016v6.972c0 .635-.089 1.162-.266 1.582a2.52 2.52 0 0 1-.714.98c-.299.243-.64.41-1.022.504-.383.103-.78.154-1.19.154-.411 0-.808-.042-1.19-.126a2.512 2.512 0 0 1-1.022-.476 2.52 2.52 0 0 1-.714-.98c-.178-.42-.266-.966-.266-1.638v-6.972h2.016z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-bms": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7C2.32 2 2 2.32 2 2.7V29.3C2 29.68 2.32 30 2.7 30H29.3C29.68 30 30 29.68 30 29.3V2.7C30 2.32 29.68 2 29.3 2ZM28.6 28.6H3.4V3.4H28.6V28.6Z"
          fill="currentColor"
        />
        <path
          d="M6.01483 19.516H6.79883C7.28416 19.516 7.67616 19.4087 7.97483 19.194C8.2735 18.9793 8.42283 18.5827 8.42283 18.004C8.42283 17.7147 8.38083 17.4767 8.29683 17.29C8.22216 17.094 8.11483 16.94 7.97483 16.828C7.84416 16.7067 7.6855 16.6227 7.49883 16.576C7.31216 16.5293 7.10683 16.506 6.88283 16.506H6.01483V19.516ZM6.01483 15.106H6.58883C7.14883 15.106 7.55483 15.008 7.80683 14.812C8.06816 14.6067 8.19883 14.266 8.19883 13.79C8.19883 13.314 8.08216 12.978 7.84883 12.782C7.61549 12.586 7.24683 12.488 6.74283 12.488H6.01483V15.106ZM3.99883 11.004H7.37283C7.78349 11.004 8.16149 11.046 8.50683 11.13C8.8615 11.214 9.16483 11.354 9.41683 11.55C9.66883 11.746 9.86483 12.0073 10.0048 12.334C10.1448 12.6607 10.2148 13.062 10.2148 13.538C10.2148 14.0793 10.0888 14.546 9.83683 14.938C9.58483 15.3207 9.20683 15.582 8.70283 15.722V15.75C9.26283 15.8247 9.70616 16.0627 10.0328 16.464C10.3595 16.8653 10.5228 17.402 10.5228 18.074C10.5228 18.466 10.4715 18.8393 10.3688 19.194C10.2662 19.5487 10.0888 19.8613 9.83683 20.132C9.59416 20.3933 9.27216 20.6033 8.87083 20.762C8.47883 20.9207 7.98883 21 7.40083 21H3.99883V11.004ZM11.8201 11.004H14.8161L16.2441 18.06H16.2721L17.7141 11.004H20.6961V21H18.8481V13.02H18.8201L17.0421 21H15.4741L13.6961 13.02H13.6681V21H11.8201V11.004ZM23.7654 17.878V18.172C23.7654 18.4053 23.7841 18.62 23.8214 18.816C23.8587 19.0027 23.9287 19.1613 24.0314 19.292C24.1341 19.4227 24.2694 19.5253 24.4374 19.6C24.6054 19.6747 24.8247 19.712 25.0954 19.712C25.4034 19.712 25.6787 19.614 25.9214 19.418C26.1734 19.2127 26.2994 18.9 26.2994 18.48C26.2994 18.256 26.2667 18.0647 26.2014 17.906C26.1454 17.738 26.0474 17.5887 25.9074 17.458C25.7674 17.3273 25.5807 17.2107 25.3474 17.108C25.1234 16.996 24.8434 16.884 24.5074 16.772C24.0594 16.6227 23.6721 16.4593 23.3454 16.282C23.0187 16.1047 22.7434 15.8993 22.5194 15.666C22.3047 15.4233 22.1461 15.148 22.0434 14.84C21.9407 14.5227 21.8894 14.1587 21.8894 13.748C21.8894 12.7587 22.1647 12.0213 22.7154 11.536C23.2661 11.0507 24.0221 10.808 24.9834 10.808C25.4314 10.808 25.8421 10.8593 26.2154 10.962C26.5981 11.0553 26.9247 11.214 27.1954 11.438C27.4754 11.6527 27.6901 11.9327 27.8394 12.278C27.9981 12.614 28.0774 13.02 28.0774 13.496V13.776H26.1454C26.1454 13.3 26.0614 12.936 25.8934 12.684C25.7254 12.4227 25.4454 12.292 25.0534 12.292C24.8294 12.292 24.6427 12.3247 24.4934 12.39C24.3441 12.4553 24.2227 12.544 24.1294 12.656C24.0454 12.7587 23.9847 12.88 23.9474 13.02C23.9194 13.16 23.9054 13.3047 23.9054 13.454C23.9054 13.762 23.9707 14.0233 24.1014 14.238C24.2321 14.4433 24.5121 14.6347 24.9414 14.812L26.4954 15.484C26.8687 15.652 27.1767 15.8293 27.4194 16.016C27.6714 16.1933 27.8674 16.3893 28.0074 16.604C28.1567 16.8093 28.2594 17.038 28.3154 17.29C28.3714 17.542 28.3994 17.822 28.3994 18.13C28.3994 19.1847 28.0914 19.9593 27.4754 20.454C26.8687 20.9487 26.0194 21.196 24.9274 21.196C23.7887 21.196 22.9721 20.944 22.4774 20.44C21.9921 19.9267 21.7494 19.208 21.7494 18.284V17.878H23.7654Z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-cm": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.65 1H1.35c-.19 0-.35.16-.35.35v13.3c0 .19.16.35.35.35h13.3c.19 0 .35-.16.35-.35V1.35c0-.19-.16-.35-.35-.35zm-.35 13.3H1.7V1.7h12.6v12.6z"
          fill="currentColor"
        />
        <path
          d="M7.232 8.68v.102c0 .216-.025.427-.074.634a1.568 1.568 0 0 1-.246.553 1.238 1.238 0 0 1-.455.387 1.555 1.555 0 0 1-.708.145c-.305 0-.559-.05-.762-.148a1.149 1.149 0 0 1-.488-.458 2.216 2.216 0 0 1-.263-.778A6.895 6.895 0 0 1 4.158 8c0-.432.026-.803.078-1.115a2.19 2.19 0 0 1 .263-.778c.123-.207.287-.359.492-.458.205-.1.459-.148.765-.148.342 0 .609.055.802.165a1.187 1.187 0 0 1 .614.896c.023.173.034.322.034.448v.087h-.768v-.081c0-.112-.01-.226-.03-.34A.932.932 0 0 0 6.3 6.37a.615.615 0 0 0-.209-.215.598.598 0 0 0-.34-.074.819.819 0 0 0-.371.078.584.584 0 0 0-.256.29 1.94 1.94 0 0 0-.148.583 7.683 7.683 0 0 0-.047.95c0 .386.016.705.047.957.031.25.081.45.148.596a.625.625 0 0 0 .256.303.77.77 0 0 0 .371.084c.162 0 .29-.04.384-.118a.76.76 0 0 0 .215-.293c.05-.117.081-.243.094-.377.013-.134.02-.258.02-.371v-.081h.768v-.001zM7.771 5.594H8.97l.849 3.565h.013l.836-3.565h1.173v4.811h-.728V6.403h-.014l-.97 4.003h-.647l-.97-4.003h-.014v4.003H7.77V5.594h.001z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-co2+humidity": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7C2.32 2 2 2.32 2 2.7V29.3C2 29.68 2.32 30 2.7 30H29.3C29.68 30 30 29.68 30 29.3V2.7C30 2.32 29.68 2 29.3 2ZM28.6 28.6H3.4V3.4H28.6V28.6Z"
          fill="currentColor"
        />
        <path
          d="M11.3792 8.57C11.3792 7.842 11.2905 7.31467 11.1132 6.988C10.9452 6.652 10.6325 6.484 10.1752 6.484C9.92317 6.484 9.71317 6.554 9.54517 6.694C9.3865 6.82467 9.2605 7.044 9.16717 7.352C9.07384 7.65067 9.0085 8.04733 8.97117 8.542C8.93384 9.02733 8.91517 9.62467 8.91517 10.334C8.91517 11.09 8.9385 11.7013 8.98517 12.168C9.04117 12.6347 9.1205 12.9987 9.22317 13.26C9.33517 13.512 9.4705 13.6847 9.62917 13.778C9.79717 13.862 9.9885 13.904 10.2032 13.904C10.3805 13.904 10.5438 13.876 10.6932 13.82C10.8518 13.7547 10.9872 13.6333 11.0992 13.456C11.2112 13.2693 11.2998 13.0127 11.3652 12.686C11.4305 12.35 11.4632 11.9113 11.4632 11.37H13.4792C13.4792 11.9113 13.4372 12.4247 13.3532 12.91C13.2692 13.3953 13.1105 13.8247 12.8772 14.198C12.6532 14.562 12.3312 14.8513 11.9112 15.066C11.5005 15.2807 10.9638 15.388 10.3012 15.388C9.54517 15.388 8.94317 15.262 8.49517 15.01C8.04717 14.7487 7.70184 14.3893 7.45917 13.932C7.22584 13.4747 7.07184 12.9287 6.99717 12.294C6.93184 11.65 6.89917 10.95 6.89917 10.194C6.89917 9.438 6.93184 8.74267 6.99717 8.108C7.07184 7.464 7.22584 6.91333 7.45917 6.456C7.70184 5.99867 8.04717 5.644 8.49517 5.392C8.94317 5.13067 9.54517 5 10.3012 5C11.0198 5 11.5845 5.11667 11.9952 5.35C12.4152 5.58333 12.7278 5.882 12.9332 6.246C13.1385 6.60067 13.2645 6.988 13.3112 7.408C13.3672 7.81867 13.3952 8.206 13.3952 8.57H11.3792Z"
          fill="currentColor"
        />
        <path
          d="M14.4187 10.194C14.4187 9.438 14.4514 8.74267 14.5167 8.108C14.5914 7.464 14.7454 6.91333 14.9787 6.456C15.2214 5.99867 15.5667 5.644 16.0147 5.392C16.4627 5.13067 17.0647 5 17.8207 5C18.5767 5 19.1787 5.13067 19.6267 5.392C20.0747 5.644 20.4154 5.99867 20.6487 6.456C20.8914 6.91333 21.0454 7.464 21.1107 8.108C21.1854 8.74267 21.2227 9.438 21.2227 10.194C21.2227 10.95 21.1854 11.65 21.1107 12.294C21.0454 12.9287 20.8914 13.4747 20.6487 13.932C20.4154 14.3893 20.0747 14.7487 19.6267 15.01C19.1787 15.262 18.5767 15.388 17.8207 15.388C17.0647 15.388 16.4627 15.262 16.0147 15.01C15.5667 14.7487 15.2214 14.3893 14.9787 13.932C14.7454 13.4747 14.5914 12.9287 14.5167 12.294C14.4514 11.65 14.4187 10.95 14.4187 10.194ZM16.4347 10.194C16.4347 10.866 16.4487 11.44 16.4767 11.916C16.514 12.3827 16.5794 12.7653 16.6727 13.064C16.7754 13.3533 16.9154 13.568 17.0927 13.708C17.2794 13.8387 17.522 13.904 17.8207 13.904C18.1194 13.904 18.3574 13.8387 18.5347 13.708C18.7214 13.568 18.8614 13.3533 18.9547 13.064C19.0574 12.7653 19.1227 12.3827 19.1507 11.916C19.188 11.44 19.2067 10.866 19.2067 10.194C19.2067 9.522 19.188 8.95267 19.1507 8.486C19.1227 8.01933 19.0574 7.63667 18.9547 7.338C18.8614 7.03933 18.7214 6.82467 18.5347 6.694C18.3574 6.554 18.1194 6.484 17.8207 6.484C17.522 6.484 17.2794 6.554 17.0927 6.694C16.9154 6.82467 16.7754 7.03933 16.6727 7.338C16.5794 7.63667 16.514 8.01933 16.4767 8.486C16.4487 8.95267 16.4347 9.522 16.4347 10.194Z"
          fill="currentColor"
        />
        <path
          d="M24.432 15.192H21.816C21.816 15.004 21.834 14.828 21.87 14.664C21.91 14.5 21.968 14.344 22.044 14.196C22.124 14.048 22.222 13.904 22.338 13.764C22.458 13.62 22.596 13.476 22.752 13.332L23.1 13.008C23.196 12.924 23.272 12.846 23.328 12.774C23.388 12.702 23.434 12.63 23.466 12.558C23.498 12.486 23.518 12.408 23.526 12.324C23.538 12.24 23.544 12.144 23.544 12.036C23.544 11.684 23.404 11.508 23.124 11.508C23.016 11.508 22.93 11.53 22.866 11.574C22.806 11.618 22.758 11.678 22.722 11.754C22.69 11.83 22.668 11.918 22.656 12.018C22.648 12.118 22.644 12.224 22.644 12.336H21.816V12.174C21.816 11.778 21.922 11.474 22.134 11.262C22.346 11.05 22.68 10.944 23.136 10.944C23.568 10.944 23.888 11.044 24.096 11.244C24.304 11.444 24.408 11.73 24.408 12.102C24.408 12.242 24.396 12.37 24.372 12.486C24.348 12.602 24.31 12.714 24.258 12.822C24.206 12.93 24.138 13.036 24.054 13.14C23.97 13.24 23.868 13.344 23.748 13.452L23.268 13.896C23.14 14.012 23.04 14.126 22.968 14.238C22.896 14.346 22.85 14.44 22.83 14.52H24.432V15.192Z"
          fill="currentColor"
        />
        <path
          d="M12.3104 17.004H14.3264V20.826H16.6784V17.004H18.6944V27H16.6784V22.562H14.3264V27H12.3104V17.004Z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-co2": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M11.38 14.379c0-.728-.09-1.256-.267-1.582-.168-.336-.48-.504-.938-.504a.95.95 0 0 0-.63.21c-.159.13-.284.35-.378.658-.093.298-.159.695-.196 1.19a23.98 23.98 0 0 0-.056 1.792c0 .756.024 1.367.07 1.834.056.466.136.83.238 1.092.112.252.247.424.406.518.168.084.36.126.574.126.178 0 .34-.028.49-.084a.885.885 0 0 0 .406-.364c.112-.187.2-.444.266-.77.066-.336.098-.775.098-1.316h2.016c0 .54-.042 1.054-.126 1.54a3.544 3.544 0 0 1-.476 1.288 2.366 2.366 0 0 1-.966.868c-.41.214-.947.322-1.61.322-.756 0-1.358-.126-1.806-.378A2.678 2.678 0 0 1 7.46 19.74c-.233-.458-.387-1.004-.462-1.638a20.884 20.884 0 0 1-.098-2.1c0-.756.033-1.452.098-2.086.075-.644.229-1.195.462-1.652A2.586 2.586 0 0 1 8.495 11.2c.448-.262 1.05-.392 1.806-.392.719 0 1.284.116 1.694.35.42.233.733.532.938.896.206.354.332.742.378 1.162.056.41.084.798.084 1.162H11.38zM14.419 16.003c0-.756.032-1.452.098-2.086.074-.644.228-1.195.462-1.652a2.587 2.587 0 0 1 1.036-1.064c.448-.262 1.05-.392 1.806-.392s1.358.13 1.806.392c.448.252.788.606 1.022 1.064.242.457.396 1.008.462 1.652.074.634.112 1.33.112 2.086 0 .756-.038 1.456-.112 2.1-.066.634-.22 1.18-.462 1.638a2.585 2.585 0 0 1-1.022 1.078c-.448.252-1.05.378-1.806.378s-1.358-.126-1.806-.378a2.678 2.678 0 0 1-1.036-1.078c-.234-.458-.388-1.004-.462-1.638a20.893 20.893 0 0 1-.098-2.1zm2.016 0c0 .672.014 1.246.042 1.722.037.466.102.849.196 1.148.102.289.242.504.42.644.186.13.429.196.728.196.298 0 .536-.066.714-.196.186-.14.326-.355.42-.644.102-.3.168-.682.196-1.148.037-.476.056-1.05.056-1.722 0-.672-.019-1.242-.056-1.708-.028-.467-.094-.85-.196-1.148-.094-.3-.234-.514-.42-.644-.178-.14-.416-.21-.714-.21-.299 0-.542.07-.728.21-.178.13-.318.345-.42.644a5.377 5.377 0 0 0-.196 1.148 29.22 29.22 0 0 0-.042 1.708zM24.432 21h-2.616c0-.187.018-.363.054-.527.04-.164.098-.32.174-.468.08-.148.178-.292.294-.432.12-.144.258-.288.414-.432l.348-.324c.096-.084.172-.162.228-.234a.93.93 0 0 0 .138-.216.746.746 0 0 0 .06-.234c.012-.084.018-.18.018-.288 0-.352-.14-.528-.42-.528a.448.448 0 0 0-.258.066.464.464 0 0 0-.144.18.98.98 0 0 0-.066.264c-.008.1-.012.206-.012.318h-.828v-.162c0-.396.106-.7.318-.912.212-.212.546-.318 1.002-.318.432 0 .752.1.96.3.208.2.312.486.312.858 0 .14-.012.268-.036.384a1.448 1.448 0 0 1-.114.336 1.64 1.64 0 0 1-.204.318c-.084.1-.186.204-.306.312l-.48.444c-.128.116-.228.23-.3.342a.95.95 0 0 0-.138.282h1.602V21z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-dew-point": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M10.665 19.516h.896c.345 0 .625-.06.84-.182.224-.121.396-.322.518-.602.13-.28.214-.649.252-1.106.046-.457.07-1.027.07-1.708 0-.57-.02-1.064-.056-1.484-.038-.43-.117-.789-.238-1.078a1.244 1.244 0 0 0-.518-.644c-.224-.15-.528-.224-.91-.224h-.854v7.028zm-2.016-8.512h3.304c.7 0 1.264.117 1.694.35.429.224.76.55.994.98.242.42.406.929.49 1.526.084.597.126 1.265.126 2.002 0 .887-.056 1.652-.168 2.296-.103.644-.285 1.176-.546 1.596-.262.42-.612.733-1.05.938-.44.205-.994.308-1.666.308H8.649v-9.996zM18.606 15.526h.896c.401 0 .723-.121.966-.364.252-.243.378-.62.378-1.134 0-.504-.108-.887-.322-1.148-.215-.261-.574-.392-1.078-.392h-.84v3.038zm-2.016-4.522h3.528c.513 0 .942.089 1.288.266.354.168.639.392.854.672.214.28.368.602.462.966.093.355.14.719.14 1.092 0 .523-.08.975-.238 1.358-.15.373-.364.681-.644.924-.271.243-.602.425-.994.546a4.39 4.39 0 0 1-1.302.182h-1.078V21H16.59v-9.996z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-dio": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M9.1 19.516h.896c.345 0 .625-.06.84-.182.224-.121.397-.322.518-.602.13-.28.215-.649.252-1.106.047-.457.07-1.027.07-1.708 0-.57-.018-1.064-.056-1.484-.037-.43-.116-.789-.238-1.078a1.244 1.244 0 0 0-.518-.644c-.224-.15-.527-.224-.91-.224H9.1v7.028zm-2.016-8.512h3.304c.7 0 1.265.117 1.694.35.43.224.76.55.994.98.243.42.406.929.49 1.526.084.597.126 1.265.126 2.002 0 .887-.056 1.652-.168 2.296-.102.644-.284 1.176-.546 1.596-.261.42-.611.733-1.05.938-.439.205-.994.308-1.666.308H7.084v-9.996zM15.124 21v-9.996h2.015V21h-2.016zm3.3-4.998c0-.756.033-1.451.099-2.086.074-.644.228-1.195.462-1.652A2.586 2.586 0 0 1 20.02 11.2c.448-.261 1.05-.392 1.806-.392s1.358.13 1.806.392c.448.252.788.607 1.022 1.064.242.457.396 1.008.462 1.652.074.635.112 1.33.112 2.086 0 .756-.038 1.456-.112 2.1-.066.635-.22 1.18-.462 1.638a2.586 2.586 0 0 1-1.022 1.078c-.448.252-1.05.378-1.806.378s-1.358-.126-1.806-.378a2.678 2.678 0 0 1-1.036-1.078c-.234-.457-.388-1.003-.462-1.638a20.863 20.863 0 0 1-.098-2.1zm2.017 0c0 .672.014 1.246.042 1.722.037.467.102.85.196 1.148.102.29.242.504.42.644.186.13.429.196.728.196.298 0 .536-.065.714-.196.186-.14.326-.355.42-.644.102-.299.168-.681.196-1.148.037-.476.056-1.05.056-1.722 0-.672-.02-1.241-.056-1.708-.028-.467-.094-.85-.196-1.148-.094-.299-.234-.513-.42-.644-.178-.14-.416-.21-.714-.21-.3 0-.542.07-.728.21-.178.13-.318.345-.42.644a5.371 5.371 0 0 0-.196 1.148 29.22 29.22 0 0 0-.042 1.708z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5 23v4H21v-4h1.5zM22.5 5v4H21V5h1.5zM18.5 23v4H17v-4h1.5zM18.5 5v4H17V5h1.5zM14.5 23v4H13v-4h1.5zM14.5 5v4H13V5h1.5zM10.5 23v4H9v-4h1.5zM10.5 5v4H9V5h1.5z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-fam": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.65 1H1.35c-.19 0-.35.16-.35.35v13.3c0 .19.16.35.35.35h13.3c.19 0 .35-.16.35-.35V1.35c0-.19-.16-.35-.35-.35zm-.35 13.3H1.7V1.7h12.6v12.6z"
          fill="currentColor"
        />
        <path
          d="M2.576 5.5h2.668v.672h-1.87v1.386h1.758v.672H3.374v2.269h-.798V5.5zM6.505 5.5h1.022l1.317 5h-.833l-.308-1.225H6.24L5.918 10.5h-.833l1.422-5h-.002zM7.57 8.637l-.574-2.465h-.014l-.595 2.465h1.184-.001zM9.194 5.5h1.246l.883 3.704h.014l.869-3.704h1.219v5h-.756V6.34h-.014l-1.008 4.16h-.672L9.967 6.34h-.014v4.16h-.756v-5h-.003z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-fame": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M4 12h4.494v1.322H5.622v1.883h2.703v1.322H5.622V20H4v-8zM10.576 16.986h1.577l-.777-3.597h-.023l-.777 3.597zM10.362 12h2.005l2.129 8h-1.69l-.372-1.692h-2.14L9.922 20h-1.69l2.13-8zM15.089 12h2.41l1.15 5.647h.022L19.83 12h2.4v8h-1.488v-6.387h-.022L19.29 20h-1.262l-1.43-6.387h-.023V20h-1.487v-8zM27.887 12v1.322h-2.872v1.883h2.703v1.322h-2.703v2.15H28V20h-4.607v-8h4.494z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-fd": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.65 1H1.35a.35.35 0 0 0-.35.35v13.3a.35.35 0 0 0 .35.35h13.3a.35.35 0 0 0 .35-.35V1.35a.35.35 0 0 0-.35-.35zm-3.367.7h.809l-2.8 4.8a1.993 1.993 0 0 0-.6-.357L11.283 1.7zM3.391 14.3H1.7V1.7h9.043L8.218 6.028a1.983 1.983 0 0 0-1.827 3.131l-3 5.141zm1.35 0h-.809l2.79-4.783c.18.151.385.27.606.35L4.741 14.3zm9.561 0h-9.02l2.524-4.326a1.982 1.982 0 0 0 1.817-3.113L12.634 1.7H14.3l.002 12.6z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-frost": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M16.55 24.447V7.553c0-.289-.253-.565-.549-.553a.56.56 0 0 0-.548.553V23.76c0 .22-.002.439 0 .658v.03c0 .289.252.566.548.553a.56.56 0 0 0 .549-.553z"
          fill="currentColor"
        />
        <path
          d="m18.28 8.487-.904.91-1.436 1.45-.33.331h.776l-.903-.91-1.437-1.45-.329-.33c-.203-.205-.576-.22-.775 0-.2.22-.217.563 0 .78l.903.911 1.437 1.449.329.331c.21.212.564.212.775 0l.903-.91L18.725 9.6l.33-.331c.202-.205.217-.581 0-.782a.553.553 0 0 0-.776 0zM19.056 22.73l-2.669-2.69a.552.552 0 0 0-.775 0l-2.668 2.69c-.203.205-.218.581 0 .782.22.203.56.22.775 0l2.668-2.69h-.775l2.669 2.69c.203.205.576.22.775 0a.566.566 0 0 0 0-.781zM23.53 19.745l-.39-.226-1.054-.614c-.52-.304-1.043-.607-1.564-.91a633.21 633.21 0 0 1-1.901-1.108l-2.082-1.213c-.704-.41-1.407-.818-2.111-1.23-.654-.379-1.307-.76-1.961-1.14l-1.664-.968-1.191-.693-.565-.33-.024-.014c-.248-.146-.612-.067-.749.199-.139.263-.07.602.197.755l.39.227 1.054.614 1.565.91c.634.369 1.268.738 1.9 1.108l2.082 1.213c.704.409 1.408.818 2.111 1.229.655.38 1.307.761 1.962 1.14l1.663.968c.396.23.793.463 1.192.693l.564.33.024.015c.249.146.612.066.75-.199.136-.262.067-.6-.198-.756z"
          fill="currentColor"
        />
        <path
          d="m10.689 10.257.33 1.242.527 1.98.12.453.384-.68c-.411.11-.82.221-1.232.333l-1.963.531-.45.122c-.277.075-.473.398-.383.68a.559.559 0 0 0 .674.387c.412-.11.821-.221 1.232-.334l1.963-.53.45-.122a.564.564 0 0 0 .384-.68l-.331-1.242a14471.099 14471.099 0 0 1-.647-2.433c-.075-.28-.395-.477-.675-.387a.564.564 0 0 0-.383.68zM23.304 16.7c-.412.11-.821.22-1.232.333l-1.963.53-.45.122a.564.564 0 0 0-.384.68l.331 1.243.527 1.979.12.453c.075.28.395.478.675.387a.565.565 0 0 0 .383-.68l-.33-1.242-.527-1.98-.12-.453-.384.68c.411-.11.82-.22 1.232-.333l1.963-.531.45-.122c.277-.075.473-.398.383-.68-.091-.287-.376-.468-.674-.387zM9.024 20.7l.39-.227 1.054-.614 1.565-.91a642.33 642.33 0 0 0 1.9-1.108l2.082-1.213c.704-.41 1.408-.818 2.111-1.23.655-.379 1.307-.76 1.962-1.14l1.663-.968 1.192-.693c.188-.11.378-.217.564-.33l.024-.014c.249-.144.357-.507.198-.756a.556.556 0 0 0-.75-.199l-.39.227-1.054.613c-.52.305-1.044.607-1.564.91-.635.37-1.269.738-1.901 1.109-.695.403-1.39.809-2.082 1.212l-2.111 1.23-1.961 1.14-1.663.968c-.397.23-.794.463-1.192.693-.188.11-.378.218-.565.33l-.024.015c-.248.143-.356.506-.197.755.16.255.483.354.75.2z"
          fill="currentColor"
        />
        <path
          d="m20.253 9.962-.33 1.242-.527 1.98-.12.453a.561.561 0 0 0 .383.68 19570.723 19570.723 0 0 0 3.195.864l.45.122c.275.076.608-.094.674-.387.066-.29-.086-.6-.384-.68-.411-.11-.82-.221-1.232-.333l-1.963-.531-.45-.122.384.68.331-1.242.527-1.98.12-.453c.075-.278-.093-.614-.384-.68-.288-.064-.594.089-.674.387zM8.404 17.765c.411.11.82.22 1.232.333l1.963.531.45.122-.384-.68-.331 1.242-.526 1.98-.121.453c-.075.278.093.613.384.68.289.066.596-.087.674-.387l.331-1.242.526-1.98.121-.453a.561.561 0 0 0-.384-.68c-.411-.11-.82-.222-1.232-.334l-1.963-.53-.45-.122c-.275-.076-.608.094-.674.387-.064.29.088.6.384.68z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-glt": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M11.164 13.972c0-.177-.023-.364-.07-.56a1.652 1.652 0 0 0-.196-.546 1.179 1.179 0 0 0-.364-.406.803.803 0 0 0-.518-.168c-.485 0-.835.27-1.05.812-.214.541-.322 1.437-.322 2.688 0 .607.019 1.153.056 1.638.038.476.103.887.196 1.232.103.336.243.597.42.784a.995.995 0 0 0 1.106.168 1.22 1.22 0 0 0 .406-.294c.131-.13.238-.294.322-.49.084-.205.126-.443.126-.714v-1.022h-1.33V15.61h3.262V21h-1.484v-.924h-.028c-.242.392-.536.677-.882.854-.336.177-.742.266-1.218.266-.616 0-1.12-.112-1.512-.336-.382-.233-.686-.574-.91-1.022-.214-.448-.359-.999-.434-1.652a20.75 20.75 0 0 1-.112-2.296c0-.84.052-1.577.154-2.212.112-.635.299-1.162.56-1.582.262-.43.607-.751 1.036-.966.43-.215.966-.322 1.61-.322 1.102 0 1.895.275 2.38.826.486.541.728 1.32.728 2.338h-1.932zM14.506 21v-9.996h2.016v8.344h3.57V21h-5.586zm11.293-9.996v1.652h-2.184V21H21.6v-8.344h-2.184v-1.652H25.8z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-mbs": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M27.687 11v1.652h-3.57v2.352h3.36v1.652h-3.36v2.688h3.71v1.652H22.1V11h5.586zM16.337 19.512h.784c.486 0 .878-.107 1.176-.322.299-.215.448-.611.448-1.19 0-.29-.042-.527-.126-.714a1.058 1.058 0 0 0-.322-.462 1.066 1.066 0 0 0-.476-.252 2.537 2.537 0 0 0-.616-.07h-.868v3.01zm0-4.41h.574c.56 0 .966-.098 1.218-.294.262-.205.392-.546.392-1.022s-.116-.812-.35-1.008c-.233-.196-.602-.294-1.106-.294h-.728v2.618zM14.321 11h3.374c.411 0 .789.042 1.134.126.355.084.658.224.91.42.252.196.448.457.588.784.14.327.21.728.21 1.204 0 .541-.126 1.008-.378 1.4-.252.383-.63.644-1.134.784v.028c.56.075 1.004.313 1.33.714.327.401.49.938.49 1.61 0 .392-.051.765-.154 1.12-.102.355-.28.667-.532.938-.242.261-.564.471-.966.63-.392.159-.882.238-1.47.238h-3.402V11zM4 11h2.996l1.428 7.056h.028L9.894 11h2.982v9.996h-1.848v-7.98H11l-1.778 7.98H7.654l-1.778-7.98h-.028v7.98H4V11z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-md": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.649 1h-13.3A.35.35 0 0 0 1 1.351v13.3a.35.35 0 0 0 .349.349h13.3a.35.35 0 0 0 .351-.349v-13.3A.35.35 0 0 0 14.649 1zM14.3 14.3H1.7V1.7h12.6v12.6z"
          fill="currentColor"
        />
        <path
          d="m10.257 12.343-1.13-1.13a1.168 1.168 0 0 0-1.43-1.43l-1.13-1.13a.583.583 0 1 0-.825.825l1.132 1.132A1.168 1.168 0 0 0 8.3 12.037l1.132 1.132a.586.586 0 0 0 .825 0 .583.583 0 0 0 0-.825l-.001-.001zm-1.763-.94a.7.7 0 0 1-.99-.988.7.7 0 1 1 .99.99v-.001zM10.257 2.834a.583.583 0 0 0-.825 0l-1.13 1.13a1.168 1.168 0 0 0-1.429 1.428L5.741 6.524a.583.583 0 1 0 .825.825l1.132-1.132a1.167 1.167 0 0 0 1.428-1.429l1.13-1.13a.583.583 0 0 0 0-.825v.001zM8.685 5.231a.704.704 0 0 1-.686.56.699.699 0 0 1-.494-.205.695.695 0 0 1-.193-.633.703.703 0 0 1 1.182-.357.696.696 0 0 1 .191.634v.001z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-panel": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.65 1H1.35a.354.354 0 0 0-.35.35v13.3a.354.354 0 0 0 .35.35h13.3a.353.353 0 0 0 .35-.35V1.35a.354.354 0 0 0-.35-.35zm-.35 13.3H1.7V1.7h12.6v12.6z"
          fill="currentColor"
        />
        <path
          d="M13.25 13.6H2.75a.35.35 0 0 1-.35-.35V2.75a.35.35 0 0 1 .35-.35h10.5a.35.35 0 0 1 .35.35v10.5a.35.35 0 0 1-.35.35zM3.1 12.9h9.8V3.1H3.1v9.8z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-pir": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M8.716 15.526h.896c.401 0 .723-.121.966-.364.252-.243.378-.62.378-1.134 0-.504-.107-.887-.322-1.148-.215-.261-.574-.392-1.078-.392h-.84v3.038zM6.7 11.004h3.528c.513 0 .943.089 1.288.266.355.168.64.392.854.672.215.28.369.602.462.966.093.355.14.719.14 1.092 0 .523-.08.975-.238 1.358-.15.373-.364.681-.644.924a2.63 2.63 0 0 1-.994.546 4.39 4.39 0 0 1-1.302.182H8.716V21H6.7v-9.996zM14.058 21v-9.996h2.016V21h-2.016zM17.57 11.004h3.723c.84 0 1.494.215 1.96.644.467.42.7 1.064.7 1.932 0 .672-.135 1.223-.406 1.652-.27.42-.69.69-1.26.812v.028c.346.047.62.135.826.266.206.121.364.303.476.546.112.233.187.532.224.896.047.364.075.812.084 1.344.01.532.038.938.084 1.218.056.28.177.471.364.574V21h-2.184a1.076 1.076 0 0 1-.196-.476 5.685 5.685 0 0 1-.056-.574l-.056-1.918c-.019-.392-.117-.7-.294-.924-.177-.224-.476-.336-.896-.336h-1.078V21H17.57v-9.996zm2.015 4.368h.84c.485 0 .859-.112 1.12-.336.261-.233.392-.62.392-1.162 0-.924-.466-1.386-1.4-1.386h-.952v2.884z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-sc": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.65 1H1.35c-.19 0-.35.16-.35.35v13.3c0 .19.16.35.35.35h13.3c.19 0 .35-.16.35-.35V1.35c0-.19-.16-.35-.35-.35zm-.35 13.3H1.7V1.7h12.6v12.6z"
          fill="currentColor"
        />
        <path
          d="M5.453 8.916v.122c0 .589.263.883.788.883a.705.705 0 0 0 .543-.219.712.712 0 0 0 .185-.481c0-.252-.061-.441-.182-.57a1.097 1.097 0 0 0-.505-.285l-.526-.182a2.43 2.43 0 0 1-.451-.222 1.267 1.267 0 0 1-.313-.279 1.033 1.033 0 0 1-.182-.361 1.688 1.688 0 0 1-.057-.458c0-.22.036-.415.108-.583.072-.168.173-.31.303-.425.13-.115.288-.202.472-.263s.388-.091.613-.091c.31 0 .555.043.735.128.179.085.315.192.408.32.092.128.152.265.179.41.027.147.04.283.04.409v.107h-.768v-.101c0-.22-.052-.391-.155-.512-.104-.122-.276-.182-.519-.182a.78.78 0 0 0-.239.037.57.57 0 0 0-.209.118.56.56 0 0 0-.145.216.866.866 0 0 0-.054.323c0 .207.056.369.168.489.112.119.296.228.552.327l.519.189c.341.12.59.28.744.478.155.198.233.463.233.795 0 .256-.037.475-.111.657a1.149 1.149 0 0 1-.32.451c-.14.119-.307.206-.502.26a2.473 2.473 0 0 1-.657.081c-.297 0-.54-.045-.731-.135a1.19 1.19 0 0 1-.448-.347 1.228 1.228 0 0 1-.222-.472 2.284 2.284 0 0 1-.061-.515v-.115h.768l-.001-.002zM11.315 8.68v.102c0 .216-.025.427-.074.634a1.568 1.568 0 0 1-.246.553 1.238 1.238 0 0 1-.455.387 1.555 1.555 0 0 1-.708.145c-.305 0-.559-.05-.762-.148a1.149 1.149 0 0 1-.488-.458 2.216 2.216 0 0 1-.263-.778A6.895 6.895 0 0 1 8.241 8c0-.432.026-.803.078-1.115a2.19 2.19 0 0 1 .263-.778c.123-.207.287-.359.492-.458.205-.1.459-.148.765-.148.342 0 .609.055.802.165a1.187 1.187 0 0 1 .614.896c.023.173.034.322.034.448v.087h-.768v-.081c0-.112-.01-.226-.03-.34a.932.932 0 0 0-.108-.307.615.615 0 0 0-.209-.215.599.599 0 0 0-.34-.074.819.819 0 0 0-.371.078.584.584 0 0 0-.256.29 1.94 1.94 0 0 0-.148.583 7.683 7.683 0 0 0-.047.95c0 .386.016.705.047.957.031.25.081.45.148.596a.625.625 0 0 0 .256.303.77.77 0 0 0 .371.084c.162 0 .29-.04.384-.118a.76.76 0 0 0 .215-.293c.05-.117.081-.243.094-.377.013-.134.02-.258.02-.371v-.081h.768v-.001z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-sc-cp": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#ykhv94sxra)" fill="currentColor">
          <path d="M14.137 8.965H1.303a.342.342 0 0 0-.338.338v12.834c0 .183.154.338.338.338h12.834a.342.342 0 0 0 .338-.338V9.303a.342.342 0 0 0-.338-.338zM13.8 21.799H1.642V9.64H13.8V21.8z" />
          <path d="M5.262 16.603v.118c0 .568.254.852.76.852a.681.681 0 0 0 .524-.211.687.687 0 0 0 .179-.464c0-.244-.059-.426-.176-.55a1.059 1.059 0 0 0-.487-.276l-.507-.175a2.34 2.34 0 0 1-.436-.215 1.224 1.224 0 0 1-.302-.269.997.997 0 0 1-.175-.348 1.63 1.63 0 0 1-.055-.442c0-.212.034-.4.104-.563.07-.162.167-.299.292-.41a1.29 1.29 0 0 1 .456-.254 1.87 1.87 0 0 1 .591-.087c.3 0 .536.041.71.123.172.082.304.185.393.309a.98.98 0 0 1 .173.396c.026.141.039.273.039.394v.103h-.742v-.097c0-.212-.05-.377-.15-.494-.1-.118-.265-.176-.5-.176a.753.753 0 0 0-.23.036.55.55 0 0 0-.202.114.54.54 0 0 0-.14.208.836.836 0 0 0-.052.312c0 .2.054.356.162.472.108.115.285.22.533.316l.5.182c.33.117.57.271.718.461.15.191.225.447.225.767 0 .247-.036.459-.107.634a1.108 1.108 0 0 1-.309.436 1.252 1.252 0 0 1-.484.25c-.19.053-.4.079-.634.079-.287 0-.521-.044-.706-.13a1.147 1.147 0 0 1-.432-.335 1.186 1.186 0 0 1-.214-.456 2.205 2.205 0 0 1-.059-.497v-.111h.741v-.002zM10.919 16.376v.098c0 .208-.024.412-.071.612-.048.2-.127.377-.238.533-.11.156-.256.281-.439.374a1.5 1.5 0 0 1-.683.14c-.294 0-.54-.049-.735-.143a1.108 1.108 0 0 1-.471-.442c-.12-.2-.204-.45-.254-.75a6.654 6.654 0 0 1-.075-1.078c0-.417.025-.775.075-1.076.05-.3.134-.552.254-.75.118-.2.277-.347.474-.443.198-.095.443-.142.739-.142.33 0 .587.053.774.159.186.106.326.235.42.387.093.151.15.31.172.477.022.167.033.311.033.433v.084h-.741v-.078c0-.109-.01-.219-.03-.329a.9.9 0 0 0-.103-.296.593.593 0 0 0-.202-.207.578.578 0 0 0-.328-.072.79.79 0 0 0-.358.076.564.564 0 0 0-.247.28 1.873 1.873 0 0 0-.143.562c-.03.238-.045.544-.045.917 0 .372.015.68.045.923.03.242.078.434.143.575.064.141.147.239.247.293.1.054.219.08.358.08.156 0 .28-.037.37-.113.091-.076.16-.17.208-.283.048-.113.078-.234.09-.363.013-.13.02-.25.02-.358v-.079h.741zM30.864 8.965H18.029a.341.341 0 0 0-.337.338v12.834a.342.342 0 0 0 .337.338h12.835a.342.342 0 0 0 .338-.338V9.303a.342.342 0 0 0-.338-.338zm-.338 12.834H18.367V9.64h12.16V21.8z" />
          <path d="M29.513 21.124H19.38a.338.338 0 0 1-.337-.337V10.654a.338.338 0 0 1 .337-.338h10.133a.338.338 0 0 1 .338.338v10.133a.338.338 0 0 1-.338.337zm-9.795-.675h9.457v-9.457h-9.457v9.457z" />
        </g>
        <defs>
          <clipPath id="ykhv94sxra">
            <path fill="#fff" d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </svg>
    ),
    "tech-symbol-set-point": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7a.708.708 0 0 0-.7.7v26.6a.708.708 0 0 0 .7.7h26.6a.708.708 0 0 0 .7-.7V2.7a.708.708 0 0 0-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 16a7 7 0 1 1-3.152-5.848L16 14l1.414 1.414 3.933-3.932A6.972 6.972 0 0 1 23 16zm2 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-smoke": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.579 11.579h19.684v4.631H6.58V11.58zm10.42 5.21h1.159v1.737H17V16.79zm2.317 0v1.737h1.158V16.79h-1.158zm-1.158 2.316H8.895v1.158h15.052v-1.158h-5.789zm5.653-2.316h-2.18v1.737h1.311l.869-1.736zm1.294 0h1.158c.32 0 .58-.259.58-.579V11.58c0-.32-.26-.579-.58-.579H6.58c-.32 0-.579.26-.579.579v4.631c0 .32.26.58.579.58h1.158l.899 1.797a.579.579 0 0 0-.32.518v1.158c0 .32.259.579.579.579h2.894v.579c0 .32.26.579.58.579h8.105c.32 0 .579-.26.579-.579v-.579h2.894c.32 0 .58-.26.58-.579v-1.158a.579.579 0 0 0-.32-.518l.898-1.797zm-16.074 0 .869 1.737h1.31V16.79H9.032zm3.337 0v1.737h1.158V16.79h-1.158zm2.316 0v1.737h1.158V16.79h-1.158zm-2.316 4.053h8.106v.579h-8.106v-.579z"
          fill="currentColor"
        />
        <path stroke="currentColor" d="M6 6.5h21M6 25.5h21" />
      </svg>
    ),
    "tech-symbol-spl": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M8.318 17.907v.252c0 1.222.546 1.834 1.638 1.834.252 0 .471-.042.658-.126a1.409 1.409 0 0 0 .756-.784c.065-.178.098-.36.098-.546 0-.523-.126-.915-.378-1.176-.252-.271-.602-.472-1.05-.602l-1.092-.378a5.167 5.167 0 0 1-.938-.462 2.826 2.826 0 0 1-.658-.574 2.396 2.396 0 0 1-.378-.756 3.701 3.701 0 0 1-.112-.952c0-.458.074-.86.224-1.204.15-.355.36-.65.63-.882.27-.243.597-.425.98-.546.382-.131.807-.196 1.274-.196.644 0 1.152.088 1.526.266.373.177.653.4.84.672.196.26.322.546.378.854.056.298.084.578.084.84v.224h-1.596v-.21c0-.458-.108-.812-.322-1.064-.215-.252-.574-.378-1.078-.378-.168 0-.336.028-.504.084a1.168 1.168 0 0 0-.434.238c-.122.112-.22.26-.294.448-.075.186-.112.41-.112.672 0 .429.116.77.35 1.022.233.242.616.466 1.148.672l1.078.392c.71.252 1.222.583 1.54.994.326.41.49.96.49 1.652 0 .532-.08.989-.238 1.372-.15.373-.369.686-.658.938-.29.242-.64.42-1.05.532a5.054 5.054 0 0 1-1.358.168c-.616 0-1.125-.094-1.526-.28-.392-.187-.7-.425-.924-.714a2.628 2.628 0 0 1-.462-.98 4.783 4.783 0 0 1-.126-1.078v-.238h1.596zM14.345 11.005h3.164c.476 0 .887.074 1.232.224.355.14.645.34.869.602.224.252.387.555.49.91.111.354.167.746.167 1.176 0 .896-.256 1.614-.77 2.156-.503.532-1.222.798-2.155.798h-1.4V21h-1.597v-9.996zm1.596 4.662h1.135c.214 0 .415-.028.601-.084.197-.066.37-.164.518-.294.15-.14.267-.318.35-.532a2.32 2.32 0 0 0 .127-.812c0-.542-.127-.966-.378-1.274-.253-.308-.696-.462-1.33-.462h-1.022v3.458zM21.163 11.005h1.596v8.652h3.864V21h-5.46v-9.996z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-switch": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.65 1H1.35c-.19 0-.35.16-.35.35v13.3c0 .19.16.35.35.35h13.3c.19 0 .35-.16.35-.35V1.35c0-.19-.16-.35-.35-.35zm-.35 13.3H1.7V1.7h12.6v12.6z"
          fill="currentColor"
        />
        <path
          d="M13.25 13.6H2.75a.35.35 0 0 1-.35-.35V2.75a.35.35 0 0 1 .35-.35h10.5a.35.35 0 0 1 .35.35v10.5a.35.35 0 0 1-.35.35zM3.1 12.9h9.8V3.1H3.1v9.8z"
          fill="currentColor"
        />
        <path
          d="M6.8 5H5.2a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V5.2a.2.2 0 0 0-.2-.2zM10.8 5H9.2a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V5.2a.2.2 0 0 0-.2-.2zM6.8 9H5.2a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V9.2a.2.2 0 0 0-.2-.2zM10.8 9H9.2a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V9.2a.2.2 0 0 0-.2-.2z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-temp": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M18.689 11.004v1.652h-2.184V21h-2.016v-8.344h-2.184v-1.652h6.384z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-temp-humidity": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M14.8 11.004v1.652h-2.185V21H10.6v-8.344H8.415v-1.652H14.8zM15.674 11.004h2.016v3.822h2.352v-3.822h2.016V21h-2.016v-4.438H17.69V21h-2.016v-9.996z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-valve": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M6.5 10.5v10.995a1 1 0 0 0 1 1h.817a1 1 0 0 0 .54-.159l4.784-3.072a1 1 0 0 1 .54-.159h3.635a1 1 0 0 1 .54.159l4.784 3.072a1 1 0 0 0 .54.16H24.497a1 1 0 0 0 1-1V10.5a1 1 0 0 0-1-1h-.777a1 1 0 0 0-.6.2l-4.744 3.555a1 1 0 0 1-.6.2h-3.555a1 1 0 0 1-.6-.2L8.877 9.7a1 1 0 0 0-.6-.2H7.5a1 1 0 0 0-1 1z"
          stroke="#4F5155"
        />
        <path fill="currentColor" d="M13.888 13.455h4.222v5.65h-4.222z" />
      </svg>
    ),
    "tech-symbol-vav": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path d="m3 25 26-7M3 7l26 7" stroke="#4F5155" strokeWidth="2" />
      </svg>
    ),
    "tech-symbol-voc": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="m6.419 11.005 1.414 7.392h.042l1.484-7.392h2.086L9.149 21h-2.59l-2.296-9.996h2.156zM11.97 16.003c0-.756.033-1.452.098-2.086.075-.644.23-1.195.463-1.652a2.586 2.586 0 0 1 1.035-1.064c.448-.262 1.05-.392 1.806-.392s1.358.13 1.806.392c.448.252.79.606 1.023 1.064.242.457.396 1.008.462 1.652.074.634.111 1.33.111 2.086 0 .756-.037 1.456-.111 2.1-.066.634-.22 1.18-.462 1.638a2.586 2.586 0 0 1-1.023 1.078c-.448.252-1.05.378-1.806.378-.755 0-1.357-.126-1.806-.378a2.678 2.678 0 0 1-1.036-1.078c-.233-.458-.387-1.004-.461-1.638a20.863 20.863 0 0 1-.099-2.1zm2.016 0c0 .672.014 1.246.042 1.722.038.466.103.849.197 1.148.102.289.242.504.42.644.186.13.429.196.728.196.298 0 .536-.066.714-.196.186-.14.326-.355.42-.644.102-.3.167-.682.195-1.148.038-.476.056-1.05.056-1.722 0-.672-.018-1.242-.055-1.708-.029-.467-.094-.85-.197-1.148-.093-.3-.233-.514-.42-.644-.177-.14-.415-.21-.713-.21-.3 0-.542.07-.728.21-.178.13-.318.345-.42.644a5.371 5.371 0 0 0-.197 1.148 29.22 29.22 0 0 0-.042 1.708zM24.23 14.379c0-.728-.089-1.256-.266-1.582-.168-.336-.48-.504-.938-.504a.95.95 0 0 0-.63.21c-.159.13-.285.35-.378.658-.094.298-.159.695-.196 1.19a23.943 23.943 0 0 0-.056 1.792c0 .756.023 1.367.07 1.834.056.466.135.83.238 1.092.112.252.247.424.406.518.168.084.36.126.574.126.177 0 .34-.028.49-.084a.885.885 0 0 0 .406-.364c.112-.187.2-.444.266-.77.065-.336.098-.775.098-1.316h2.016c0 .54-.042 1.054-.126 1.54a3.544 3.544 0 0 1-.476 1.288 2.366 2.366 0 0 1-.966.868c-.41.214-.948.322-1.61.322-.756 0-1.358-.126-1.806-.378a2.678 2.678 0 0 1-1.036-1.078c-.234-.458-.388-1.004-.462-1.638a20.863 20.863 0 0 1-.098-2.1c0-.756.032-1.452.098-2.086.074-.644.228-1.195.462-1.652a2.586 2.586 0 0 1 1.036-1.064c.448-.262 1.05-.392 1.806-.392.718 0 1.283.116 1.694.35.42.233.732.532.938.896.205.354.331.742.378 1.162.056.41.084.798.084 1.162H24.23z"
          fill="currentColor"
        />
      </svg>
    ),
    "tech-symbol-window": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7c-.38 0-.7.32-.7.7v26.6c0 .38.32.7.7.7h26.6c.38 0 .7-.32.7-.7V2.7c0-.38-.32-.7-.7-.7zm-.7 26.6H3.4V3.4h25.2v25.2z"
          fill="currentColor"
        />
        <path
          d="M21 7H10.5a.5.5 0 0 0-.5.5v13.21a.5.5 0 0 0 .5.5h2.167M21 7v13.889a.5.5 0 0 1-.293.455l-7.333 3.334a.5.5 0 0 1-.707-.455v-3.012M21 7l-8.054 3.968a.5.5 0 0 0-.28.448v9.794"
          stroke="#4F5155"
        />
      </svg>
    ),
    "tech-symbol-x-cube": (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.3 2H2.7C2.32 2 2 2.32 2 2.7V29.3C2 29.68 2.32 30 2.7 30H29.3C29.68 30 30 29.68 30 29.3V2.7C30 2.32 29.68 2 29.3 2ZM28.6 28.6H3.4V3.4H28.6V28.6Z"
          fill="currentColor"
        />
        <path
          d="M12.0202 11.004H14.2462L15.5342 14.238L16.8082 11.004H19.0062L16.6822 15.946L19.1742 21H16.9062L15.4642 17.612L14.0362 21H11.8242L14.3162 15.946L12.0202 11.004Z"
          fill="currentColor"
        />
      </svg>
    ),
    "folder-regular": (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.29 3H7.31V1.75c0-.41-.34-.75-.75-.75H1.75c-.41 0-.75.34-.75.75V13.3c0 .94.76 1.7 1.7 1.7h10.6c.94 0 1.7-.76 1.7-1.7V4.75C15 3.79 14.23 3 13.29 3zM2.5 2.5h3.31v1.25c0 .41.33.75.75.75h6.73c.12 0 .21.11.21.25v.5h-11V2.5zm11 10.8a.2.2 0 0 1-.2.2H2.7a.2.2 0 0 1-.2-.2V6.75h11v6.55z"
          fill="currentColor"
        />
      </svg>
    ),
  };

  return <div {...props}>{icons[name]}</div>;
};
